export class Group {
  constructor(
    public docType: string,
    public docClass: string,
    public docSafe: string,
  ) {}
}
